import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/meet-linda", label: "Meet Linda" },
  { to: "/achievements", label: "Achievements" },
  { to: "/priorities", label: "Priorities" },
  { to: "/news", label: "News" },
  { to: "/volunteer", label: "Volunteer" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <header
      data-testid="main-nav"
      className="sticky top-0 z-50 bg-background/95 backdrop-blur border-b border-border"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-home">
          <div className="flag-rule"><span /><span /><span /></div>
          <div className="leading-tight">
            <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground font-medium">
              Friends of
            </div>
            <div className="font-serif text-lg font-bold text-primary">
              Linda Burke
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `nav-link text-sm font-medium uppercase tracking-wider ${
                  isActive ? "active text-primary" : "text-foreground/80 hover:text-primary"
                }`
              }
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/donate"
            data-testid="nav-donate"
            className="bg-accent text-accent-foreground px-5 py-2.5 text-sm font-bold uppercase tracking-wider hover:bg-[#8A1333] transition-colors"
          >
            Donate
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-background border-t border-border">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={`py-2 text-base font-medium ${
                  loc.pathname === l.to ? "text-accent" : "text-foreground"
                }`}
                data-testid={`mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/donate"
              onClick={() => setOpen(false)}
              className="bg-accent text-accent-foreground text-center py-3 font-bold uppercase tracking-wider"
            >
              Donate
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
